<nb-tabset fullWidth>
    <nb-tab *ngFor="let tab of tabs" [tabTitle]="tab.title" [active]="tab.active">
        
        <label class="horizontal control-label">{{ to.questionLabel }}</label>
        <input nbInput type="text" fullWidth [(ngModel)]="model[to.questionKey][tab.lang]">
        
        <label class="horizontal control-label mt-2">{{ to.answerLabel }}</label>
        <editor [init]="editorConfig" [(ngModel)]="model[to.answerKey][tab.lang]">
        </editor>

    </nb-tab>
</nb-tabset>

